<button class="button icon-button"
        (click)="$event.stopPropagation()"
        #menuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="menu"
        [class.open]="menuTrigger.menuOpen">
  <app-icon name="ic_menu"/>
</button>
<mat-menu #menu="matMenu" xPosition="before">
  @for (item of menuItems; track item.labelKey) {
    <button mat-menu-item [disabled]="item.disabled" (click)="item.action()">{{ item.labelKey | translate }}</button>
  }
</mat-menu>
